import React from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-seo');
import { Seo } from '../elements/seo';
import { startCase } from 'lodash';
export var EntitySeoDefaultProps = {}; // -------- Child Component Props -------->
// -------- Components -------->

var My = {
  Seo: Seo
};
export var EntitySeo = function EntitySeo(props) {
  var className = props.className,
      entity = props.entity;
  var openGraph = entity.openGraph,
      name = entity.name;
  var entityTypeLabel = startCase(entity.__typename);
  var title = openGraph && openGraph.title || entity.name;
  return React.createElement(My.Seo, {
    title: title + " - " + entityTypeLabel
  });
};
EntitySeo.defaultProps = EntitySeoDefaultProps;
EntitySeo.cls = cls;